import React from 'react';
import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { AutoFixHighRounded } from '@mui/icons-material';

type ActionResponse = { hasBranding?: boolean; source?: string } | string | null;
type ActionArgs = { privateProfileId?: string };

export type AndieRegenerateProfileBrandingProps = ActionRenderAi<ActionResponse, ActionArgs>;

const AndieRegenerateProfileBranding = (props: AndieRegenerateProfileBrandingProps) => {
    const { t } = useTranslation();
    return (
        <AndieGenericToolRender<ActionResponse, ActionArgs>
            title={() => t('andie.tool.regenerate-profile-branding.title')}
            icon={<AutoFixHighRounded fontSize="small" />}
            privateProfileId={props.args?.privateProfileId}
            loadingMessages={() => [t('andie.tool.regenerate-profile-branding.loading')]}
            completeMessage={() => t('andie.tool.regenerate-profile-branding.complete')}
            {...props}
        />
    );
};

export default AndieRegenerateProfileBranding;
